export default "__VITE_ASSET__DCCqV705__"